<template>
  <el-table-column
    prop="shop_id"
    sortable="custom"
    label="Bolt #"
    min-width="100"
  >
    <template slot-scope="scope">
      {{ scope.row.shop_id }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',
  };
</script>
